import React from 'react';
import './App.css';
import Context from './components/Context';

const App: React.FC = () => {
  return (
    <>
      <Context >
      </Context>
    </>
  );
}

export default App;